var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reject"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reject",
    clipPath: "url(#clip-Reject)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7580",
    "data-name": "Rectangle 7580",
    width: 18,
    height: 17.997,
    rx: 8.998,
    transform: "translate(1 1.002)",
    fill: "#f0d9db"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1434",
    "data-name": "Line 1434",
    y2: 7.561,
    transform: "translate(12.673 7.328) rotate(45)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1435",
    "data-name": "Line 1435",
    y2: 7.561,
    transform: "translate(12.674 12.674) rotate(135)",
    fill: "none",
    stroke: "#d3221e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.5eb0154a0bbbb6219b03da1275da68f9.svg";
export { ForwardRef as ReactComponent };